
import React from 'react'
import AllProductsHero from './AllProductsHero'
import AllProducts from './AllProducts'

const AllProductsPage = () => {
  return (
    <div>
      <AllProductsHero/>
      <AllProducts/>
    </div>
  )
}

export default AllProductsPage
